// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const Bem = require('shared/bem')
// Client V2 common imports
const { useIsHydrated } = require('client-v2/common/hooks/server-side-rendering')
const tag = require('client-v2/common/utils/hyperscript')

const bemEntity = Bem.entity('EmojiMentionsInput')

const EmojiMentionsInput = React.lazy(
  () => new Promise((resolve, reject) => {
    require.ensure(
      [ './emoji-mentions-input' ],
      require => {
        // Compatibility: React.lazy expects the shape of an ES Module;
        // convert CommonJS exports to look like an ES Module default
        const moduleExports = require('./emoji-mentions-input')
        resolve({ default: moduleExports })
      },
      reject,
      'emoji-mentions-input'
    )
  })
)

function EmojiMentionsInputLazy(props) {
  const isHydrated = useIsHydrated()
  const fallback = (
    tag(EmojiMentionsInputLazyLoading, {
      className: props.className
    })
  )
  if (!isHydrated) {
    // Suspense is not supported in Server-side Rendering
    return fallback
  }
  return (
    tag(React.Suspense, {
      fallback
    },
      tag(EmojiMentionsInput, props)
    )
  )
}

function EmojiMentionsInputLazyLoading(props) {
  return (
    tag('div', {
      className: classNames(
        props.className,
        bemEntity.block({ lazy: true })
      )
    })
  )
}

module.exports = EmojiMentionsInputLazy
